import styled from 'styled-components';
export const StyledDownCaratIconWrapper = styled.span.withConfig({
  displayName: "NavBarstyle__StyledDownCaratIconWrapper"
})(({
  $iconSize
}) => {
  return {
    display: 'inline-block',
    verticalAlign: 'middle',
    fontSize: $iconSize,
    marginLeft: '4px'
  };
});